var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.864 14.5657C21.3063 14.1203 20.9909 13.3624 20.3631 13.3624H18.7313C18.3415 13.3624 18.0254 13.0463 18.0254 12.6565V6.70686C18.0254 6.31701 17.7094 6.00098 17.3196 6.00098H12.6809C12.2911 6.00098 11.975 6.31701 11.975 6.70686V12.6565C11.975 13.0463 11.659 13.3624 11.2691 13.3624H9.63731C9.00961 13.3624 8.69414 14.1203 9.13647 14.5657L14.4994 19.9655C14.7754 20.2435 15.225 20.2435 15.5011 19.9655L20.864 14.5657Z",
    fill: "#616874"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94141 23.2934V21.8817C7.94141 21.4918 8.25744 21.1758 8.64729 21.1758H21.3532C21.743 21.1758 22.0591 21.4918 22.0591 21.8817V23.2934C22.0591 23.6833 21.743 23.9993 21.3532 23.9993H8.64729C8.25744 23.9993 7.94141 23.6833 7.94141 23.2934Z",
    fill: "#616874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.1c4891a913df81fb1402482c5f6460ba.svg";
export { ForwardRef as ReactComponent };